// extracted by mini-css-extract-plugin
export default {"wrapper":"AcademicProgram_wrapper__SerIx"};